"use client";

import React from "react";
import { Plane, Map, ShieldCheck, ChevronRight, Briefcase, Award, Users } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Team offsites & retreats",
  description: "For teams who want more than a meeting room. Genuine Hong Kong experiences that combine focused work sessions with genuine Hong Kong experiences — so people leave with both clarity and a story to tell. moments.",
  icon: Users,
  link: "/ServicesPage"
}, {
  title: "Incentive & VIP travel",
  description: "High-end itineraries for top performers and visiting clients that feel personal and considered",
  icon: Award,
  link: "/ServicesPage"
}, {
  title: "Business visitor programmes",
  description: "Keep international guests engaged between meetings with curated city experiences. building lasting bonds within your organization.",
  icon: Briefcase,
  link: "/ServicesPage"
}];
export default function NuestraPropuestaDeValor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222785" id="curated-experiences" className="py-20 bg-background relative overflow-hidden text-foreground">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <h2 className="font-serif text-4xl md:text-5xl font-semibold text-primary mb-12 tracking-tight">Perfect for:</h2>
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full flex flex-col bg-card border-primary/10 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-primary/5 group">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary/10 group-hover:bg-ring/20 transition-colors duration-300">
                      <Icon className="h-6 w-6 text-ring stroke-[1.5]" />
                    </div>
                    <CardTitle className="font-default text-xl tracking-tight text-primary">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="font-default text-base leading-relaxed text-muted-foreground line-clamp-4">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-2 pb-6">
                    <Link to={service.link} className="inline-flex items-center text-sm font-medium text-secondary hover:text-ring transition-colors duration-200 group/link">
                      View Experience
                      <ChevronRight className="ml-1 h-4 w-4 transition-transform duration-200 group-hover/link:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}